import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap';
import { BiHome, BiLogOutCircle, BiMenu, BiMoneyWithdraw } from 'react-icons/bi';
import { BsArrowLeftSquareFill } from 'react-icons/bs';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../../../Redux/Slice/Auth/authSlice';
import { useDispatch } from 'react-redux';
import { ImUsers } from 'react-icons/im';
import { FaFirstOrder } from 'react-icons/fa';
import { MdConnectWithoutContact } from 'react-icons/md';
import { RiDashboardFill } from 'react-icons/ri';
import { IoNewspaperSharp } from 'react-icons/io5';

const Sidebar = () => {

    const location = useLocation()
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
    });



    const handleLogout = async () => {
        dispatch(logout());
        navigate('/')
    }

    const dispatch = useDispatch();
    const navigate = useNavigate()

    const [onHover, setOnHover] = useState(false);
    const [toggle, setToggle] = useState(false);


    useEffect(() => {
        const handleResize = () => {
            setScreenSize({
                width: window.innerWidth,
            });
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [])



    useEffect(() => {
        if (screenSize.width <= 1024) {
            setToggle(false);
        }
    }, [location.pathname]);


    return (
        <>
            <div
                className={`wrapper ${toggle ? "toggled" : ""} ${onHover ? "sidebar-hovered" : ""
                    }`}
            >
                {/*sidebar wrapper */}
                <div
                    className="sidebar-wrapper"
                    data-simplebar="true"
                // onMouseEnter={() => setOnHover(true)}
                // onMouseLeave={() => setOnHover(false)}
                >
                    <div className="sidebar-header">
                        {/* <div>
                            <img
                                src={logo}
                                className="logo-icon"
                                alt="logo icon"
                            />
                        </div> */}
                        <div>
                            <h4 className="logo-text" >Popgop</h4>
                        </div>
                        <div
                            className="toggle-icon ms-auto mob-toggle"
                            onClick={() => setToggle(!toggle)}
                        >
                            <BsArrowLeftSquareFill />
                        </div>
                    </div>
                    {/*navigation*/}
                    <ul className="metismenu mm-show" id="menu">
                        <li >
                            <Link to="/admin" className={`${location?.pathname === "/admin" ? "sidebarItem-active text-decoration-none " : "text-decoration-none"}`}>
                                <div className="parent-icon d-flex">
                                    {/* <i className="fas fa-id-card-alt font-14"></i> */}
                                    <RiDashboardFill />


                                </div>
                                <div className="menu-title">Dashboard</div>
                            </Link>
                        </li>

                        <li>
                            <Link to="/admin/withdrawal" className={`${location?.pathname === "/admin/withdrawal" ? "sidebarItem-active text-decoration-none " : "text-decoration-none"}`}>
                                <div className="parent-icon d-flex">
                                    {/* <i className="fas fa-id-card-alt font-14"></i> */}
                                    <BiMoneyWithdraw />


                                </div>
                                <div className="menu-title">Withdrawal</div>
                            </Link>
                        </li>

                        <li>
                            <Link to="/admin/users" className={`${location?.pathname === "/admin/users" ? "sidebarItem-active text-decoration-none " : "text-decoration-none"}`}>
                                <div className="parent-icon d-flex">
                                    {/* <i className="fas fa-id-card-alt font-14"></i> */}
                                    <ImUsers />


                                </div>
                                <div className="menu-title">Users</div>
                            </Link>
                        </li>

                        <li>
                            <Link to="/admin/commissions" className={`${location?.pathname === "/admin/commissions" ? "sidebarItem-active text-decoration-none " : "text-decoration-none"}`}>
                                <div className="parent-icon d-flex">
                                    {/* <i className="fas fa-id-card-alt font-14"></i> */}
                                    <MdConnectWithoutContact />


                                </div>
                                <div className="menu-title">Commission</div>
                            </Link>
                        </li>

                        <li>
                            <Link to="/admin/orders" className={`${location?.pathname === "/admin/orders" ? "sidebarItem-active text-decoration-none " : "text-decoration-none"}`}>
                                <div className="parent-icon d-flex">
                                    {/* <i className="fas fa-id-card-alt font-14"></i> */}
                                    <FaFirstOrder />


                                </div>
                                <div className="menu-title"> Referal Orders</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/newsletters" className={`${location?.pathname === "/admin/newsletters" ? "sidebarItem-active text-decoration-none " : "text-decoration-none"}`}>
                                <div className="parent-icon d-flex">
                                    {/* <i className="fas fa-id-card-alt font-14"></i> */}
                                    <IoNewspaperSharp />
                                </div>
                                <div className="menu-title"> Newsletters</div>
                            </Link>
                        </li>

                        <li>
                            <div onClick={handleLogout}>

                                <Link

                                    className="text-decoration-none">
                                    <div className="parent-icon d-flex">
                                        {/* <i className="fas fa-id-card-alt font-14"></i> */}
                                        <BiLogOutCircle />
                                    </div>
                                    <div className="menu-title">Logout</div>
                                </Link>
                            </div>
                        </li>

                        {/* <li>
                            <Link to="/setting" className="text-decoration-none">
                                <div className="parent-icon d-flex">
                                    <BiCog />
                                </div>
                                <div className="menu-title">Setting</div>
                            </Link>
                        </li> */}
                    </ul>
                    {/*end navigation*/}
                </div>

                <header>
                    <div className="topbar d-flex align-items-center">
                        <nav className="navbar navbar-expand">
                            <div
                                className=""
                                onClick={() => setToggle(!toggle)}
                            >
                                <BiMenu size={26} />
                            </div>

                            {/* <div className="search-bar flex-grow-1">
                                <div className="position-relative search-bar-box">
                                    <input
                                        type="text"
                                        className="form-control bg-transparent search-control"
                                        placeholder="Type to search..."
                                    />
                                    <span className="position-absolute top-50 search-show translate-middle-y">
                                        <BiSearch />
                                    </span>
                                    <span className="position-absolute top-50 search-close translate-middle-y">
                                        <i className="bx bx-x" />
                                    </span>
                                </div>
                            </div> */}
                            <div className="top-menu ms-auto">
                                <ul className="navbar-nav align-items-center">

                                    <Dropdown>
                                        <Dropdown.Toggle className="bg bg-transparent border-0 text-dark" id="dropdown-basic">
                                            admin
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            {/* <Dropdown.Item as={Link} to="/change-password">Password Setting</Dropdown.Item> */}
                                            {/* <Dropdown.Divider /> */}

                                            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>

                                        </Dropdown.Menu>
                                    </Dropdown>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </header >

                <div className="page-wrapper">
                    <div className="page-content">
                        <Outlet />
                    </div>
                </div>

                <div className="overlay toggle-icon"></div>

                {/* <footer className="page-footer">
          <p className="mb-0">Copyright © 2023. All right reserved.</p>
        </footer> */}
            </div >
        </>
    )
}

export default Sidebar